import { IAppState } from "..";

export const getX10Configuration = (x10Id: string) => (state: IAppState) =>
  state.x10config.configurations[x10Id];

export const getX10ConfigHistory = (x10Id: string) => (state: IAppState) =>
  state.x10config.history[x10Id];

export const getIsLoadingX10Config = (state: IAppState) => state.x10config.loading;

export const getX10ConfigLoadError = (state: IAppState) => state.x10config.loadError;

export const getIsApplyingX10Config = (state: IAppState) => state.x10config.applying;

export const getX10ConfigApplyBlocked = (state: IAppState) => state.x10config.applyBlocked;

export const getX10ConfigLastPing = (state: IAppState) => state.x10config.lastPing;
